<template>
    <div class="card px-0 py-2">
        <h1 class="heading-medium my-1 mb-2 pl-3">Today's Negotiations</h1>
        <div class="overflow-auto py-2" >
            <div v-if="getNegotiationListChanges.length < 1" class="text-center">
                No negotiations placed
            </div>
            <div v-else class="border-top">
                <a 
                    href="#" 
                    v-for="(negotiation,key) in negotiations" :key="key" 
                    class="conversations--action d-flex py-2 justify-content-between border-bottom text-decoration-none" 
                    @click="showNegotiation(negotiation, key)"
                >
                    <div class="d-flex justify-content-between w-100">
                        <div class="d-flex justify-content-start text-tertiary">
                            <span class="conversations--image mx-3 my-2 position-relative"
                                :class="{'all-offline': !isAnySellerOnline[key]}">{{negotiation.counterOffers.length}}</span>
                            <div class="d-flex flex-column justify-content-center mr-5">
                                <h5>{{negotiation.fuel_id | fueltype}}</h5>
                                <span v-if="getFuelsType.find(fuel => fuel._id == negotiation.fuel_id).type == 'SPOT'">
                                    <span v-if="negotiation.terminal">
                                        {{negotiation.terminal.name}}
                                    </span>
                                    <span v-else>N/A</span>
                                </span>
                                <span v-else>Network</span>
                            </div>
                            <div class="d-flex flex-column justify-content-center mr-2">
                                <strong>
                                    <!-- Check whether calculated live price exceeds the negotiation's max price -->
                                    {{negotiation.type_id == 'FIXED' || negotiation.status_id == 'COMPLETED' ?
                                        negotiation.price : negotiation.livePrice | priceformat}} ppl
                                </strong>
                                <span>{{negotiation.quantity | volumeformat}} l.</span>
                            </div>
                        </div>
                        <span class="d-flex align-items-center mr-3"><i class="fas fa-caret-right text-tertiary"></i></span>
                    </div>
                </a>      
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

export default {
    data: function(){
        return {
            isAnySellerOnline: []
        }
    },
    computed: {
        ...mapState('login',['userLoggedIn']),
        ...mapState('negotiation', ['negotiationFuelGroups']),
        ...mapGetters('fuelsType', ['getFuelsType']),
        ...mapGetters('negotiation', ['getNegotiationListChanges']),
        negotiations: {
            get: function(){
                let negotiationList = []

                if (this.getNegotiationListChanges){
                    /* 
                     * Sort negotiations based on account type: (to mimic the list on Negotiations page for each account)
                     * Buyer => return as how the list is returned via API call
                     * Seller => return based on last activity - doesn't take status into consideration
                     */
                    if (this.userLoggedIn.category == 'buyer'){
                        negotiationList = this.getNegotiationListChanges
                    }
                    else if (this.userLoggedIn.category == 'seller'){
                        negotiationList = Object.assign([], this.getNegotiationListChanges.sort((a, b) => {
                            return new Date(b.lastActivity) - new Date(a.lastActivity)
                        }))
                    }

                    /* If the list contains more than 3 negotiations, then slice it to the top 3 */
                    if (this.getNegotiationListChanges.length > 3){
                        negotiationList = negotiationList.splice(0, 3)
                    }
                }

                return negotiationList
            }
        }
    },
    methods: {
        ...mapMutations('negotiation', ['SELECT_TAB']),
        ...mapActions('negotiation', ['selectNegotiation', 'selectFuelGroup', 'setNegotiationSelectedId']),
        showNegotiation: async function(negotiation, key){
        
            if (this.userLoggedIn.category == 'buyer'){
                this.selectNegotiation(negotiation._id).then(() => {
                    this.SELECT_TAB(0)
                    this.$router.push({name: 'NegotiationsBuyer'})
                })
            }
            else if (this.userLoggedIn.category == 'seller'){
                /* Select fuel group, then negotiation */
                const fuelIdSelected = negotiation.fuel_id
                const fuelGroup = await this.negotiationFuelGroups.find(fuelGroup => fuelGroup.fuel._id == fuelIdSelected)
                const negotiationIndex = await fuelGroup.negotiationList.findIndex(negotiationMatch => negotiationMatch._id == negotiation._id)
                
                this.selectFuelGroup(fuelIdSelected) // Select fuel group
                this.SELECT_TAB(negotiationIndex + 1) // Select negotiation
                this.setNegotiationSelectedId(negotiation._id)
                this.$router.push({name: 'NegotiationsSeller'})
            }
            
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/_conversations.scss";
</style>
